import { useMutation } from '@tanstack/react-query'
import APIService from 'api/APIService'
import { useId, useState } from 'react'

interface useSLTProps {
  onSuccess: (slt: string) => void
  onError: VoidFunction
}
const useSLT = ({ onSuccess, onError }: useSLTProps) => {
  const [slt, setSlt] = useState<string>('')
  const _id = useId()

  const { mutate: getSLT, isPending: isLoading } = useMutation({
    mutationKey: ['slt', _id],
    mutationFn: ({
      userId,
      authToken
    }: {
      userId: string
      authToken?: string
    }) => {
      return APIService.everlance.getSLT({ tokenId: userId, authToken })
    },
    onSuccess: ({ single_login_token }) => {
      setSlt(single_login_token)
      onSuccess(single_login_token)
    },
    onError
  })

  return {
    getSLT,
    slt,
    isLoading
  }
}

export default useSLT
